import React, { useState } from 'react';
import cn from 'classnames';
import { MoreVertical } from "../../icons";
import { Button } from "../Button";
import { DropdownMenu } from "../DropdownMenu";
import { IconButton } from "../IconButton";
import { TableList, useTableListRowContext } from "../TableList";
import styles from "./TableListActions.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Composite component used in tables as the last column that shows actions to be
 * performed on the row. Will only show itself when the row is hovered or when the
 * dropdown is opened.
 */
export function TableListActions(props) {
  const {
    buttonText,
    buttonIntent,
    secondaryButtonText,
    children,
    testId,
    btnHeapId,
    secondaryBtnHeapId,
    menuHeapId,
    onClickButton,
    onClickSecondaryButton
  } = props;
  const {
    setForceHover,
    size
  } = useTableListRowContext();
  const [isOpen, setIsOpen] = useState(false);
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": testId && "".concat(testId, "-action-root"),
    className: cn(styles.actionsWrapper, {
      [TableList.classes.showAlways]: isOpen
    }),
    onClick: e => {
      e.stopPropagation();
      e.preventDefault(); //to prevent full page navigation when wrapped in an "a" tag
    },
    children: [(buttonText || secondaryButtonText) && /*#__PURE__*/_jsxs("div", {
      className: cn(styles.buttonsWrapper, TableList.classes.showOnRowHover, {
        [styles.withoutDropdown]: !children,
        [TableList.classes.showAlways]: isOpen
      }),
      children: [buttonText && /*#__PURE__*/_jsx(Button, {
        noWrap: true,
        intent: buttonIntent,
        size: size !== 'large' ? 'small' : 'medium',
        onClick: onClickButton,
        testId: testId && "".concat(testId, "-btn"),
        "data-heapid": btnHeapId,
        children: buttonText
      }), secondaryButtonText && /*#__PURE__*/_jsx(Button, {
        noWrap: true,
        skin: "primaryOutline",
        className: styles.secondaryBtn,
        size: size !== 'large' ? 'small' : 'medium',
        onClick: onClickSecondaryButton,
        testId: testId && "".concat(testId, "-secondary-btn"),
        "data-heapid": secondaryBtnHeapId,
        children: secondaryButtonText
      })]
    }), children ? /*#__PURE__*/_jsx(DropdownMenu, {
      onOpenChange: open => {
        setIsOpen(open);
        setForceHover(open);
      },
      onClose: (anchorEl, reason) => {
        if (reason === 'backdropClick') {
          // Manually blur the anchorEl to prevent it from staying visible on a non-hovered row.
          requestAnimationFrame(() => {
            anchorEl && anchorEl.blur();
          });
        }
      },
      target: /*#__PURE__*/_jsx(IconButton, {
        testId: testId && "".concat(testId, "-dropdown-trigger"),
        "data-heapid": menuHeapId,
        children: /*#__PURE__*/_jsx(MoreVertical, {})
      }),
      testId: "".concat(testId, "-dropdown"),
      children: children
    }) : /*#__PURE__*/_jsx("div", {
      "data-testid": testId && "".concat(testId, "-dropdown-placeholder"),
      className: styles.hiddenDropdown
    })]
  });
}